var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInPersonClassFaqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33 66.37v57.72h116.06V66.15S99.17 50.13 98.1 49.98c-1.07-.15-32.26-28.7-32.26-28.7L31.46 49.01L6.33 66.37z",
    fill: "#f8c778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5b03f",
    d: "M6.33 66.31h27.4l-.03 57.72h4.55l.03-70.27L65.16 30.1l27.12 24.8l-.07 69.13h4.26l.07-58.05l25.85.18v-3.45L98.81 50.07L67.27 22.36L32.45 49.5L6.35 63.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 42.57c-.18.29-7.15 19.51-7.28 19.91c-.13.4.2.87 1 .94c.8.07 28.39 0 28.39 0l-.08-11.78s29.62-26.66 29.95-26.66s30.18 27.35 30.25 27.76c.07.4.13 10.22.13 10.22s26.25.2 26.79.27s.67-.67.2-2.07c-.47-1.4-5.95-18.3-6.35-18.57c-.4-.27-22.04-.27-22.04-.27S66.95 17.36 66.48 16.96c-.47-.4-1.87-1.01-3.11.23c-1.09 1.09-28.13 25.33-28.13 25.33s-21.94-.29-22.14.05z",
    fill: "#a62714"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.91 80.59l-.01 43.48h42.36V80.59s-42.35-.11-42.35 0z",
    fill: "#cf6150"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64 124.25c.37.56 4.69.3 16.2.36c11.51.06 14.86.04 15.46-.08c.59-.12 1.07-2.71.68-4.96c-.43-2.47-1.91-4.8-4.31-5.55c-3.21-1-5.19-.08-6.73-.62c-1.54-.53-6.05-2.79-10.62-2.49c-3.92.25-6.71 1.4-9.14 4.98c-2.61 3.85-1.78 8-1.54 8.36z",
    fill: "#7db240"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.09 124.01c.59-.41.54-11.77-7.36-12.64c-5.93-.65-7.48 1.9-8.48 1.9c-1.01 0-4.85-1.87-10.15.18c-6.59 2.55-6.47 9.97-6.23 10.68s7.06.53 16.43.59s15.02-.17 15.79-.71z",
    fill: "#7db240"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.57 69.63h18.69v15.05H11.32s.12-14.93.25-15.05z",
    fill: "#3e737c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 91.71h18.61v14.56H11.16c0 .01.08-14.64.16-14.56z",
    fill: "#3e737c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 72.38h12.7v9.95H14.24s-.09-9.87.16-9.95z",
    fill: "#a7d0d7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.83 94.14h13.43v9.63H13.83v-9.63z",
    fill: "#a7d0d7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.67 70.52h18.61v14.97H99.59s.08-15.21.08-14.97z",
    fill: "#3e737c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.26 73.11h13.35v9.71h-13.35v-9.71z",
    fill: "#a7d0d7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.43 92.6h18.53v14.16H99.43s-.12-14.03 0-14.16z",
    fill: "#3e737c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.34 95.19v8.74h12.7v-8.82s-12.82-.04-12.7.08z",
    fill: "#a7d0d7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.06 124.09l-.01-38.76h30.5v38.76H50.06z",
    fill: "#3e737c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.94 93.24v-5.1H53.82v5.1h23.12z",
    fill: "#a7d0d7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a7d0d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.82 95.79h23.12v13.27H53.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.82 111.79h23.12v6.94H53.82z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.28 94.65v26.11h2.64V94.38s-2.46.27-2.64.27z",
    fill: "#3e737c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.46 40.06c-10.37.09-17.32 7.82-16.79 17.76c.51 9.66 8.18 15.72 17.05 15.47c9.32-.26 16-7.74 16.26-16.61s-6.94-16.7-16.52-16.62z",
    fill: "#3e737c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2 43.05c-8.44 0-14.07 6.42-13.71 14.15c.34 7.46 5.36 13.1 13.98 13.1c7.91 0 13.11-6.5 13.27-13.19c.17-7.3-5.28-14.06-13.54-14.06z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.74 57.46s-4.9 4.12-5.17 4.6s-.26 1.27.39 1.8c.66.53 1.31.22 1.71-.09c.39-.31 5.56-4.55 5.56-4.55s1.67-.03 2.06-2.01c.31-1.58-.83-2.32-.83-2.32s-.18-9.46-.26-10.16c-.07-.52-.61-1.01-1.09-.96c-.48.04-.96.31-1.01 1.09c-.05.78-.1 9.84-.1 9.84s-.7.26-1.09 1.01c-.39.74-.17 1.75-.17 1.75z",
    fill: "#2f2f2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPersonClassFaqIcon);
export default __webpack_public_path__ + "static/media/in-person-class-faq-icon.5cda3f5f06e525791ffbbc93db8e8800.svg";
export { ForwardRef as ReactComponent };